export enum DeviceOperatingSystem {
  iOS = 'iOS',
  Android = 'Android',
  Windows = 'Windows',
  MacOS = 'MacOS',
  Linux = 'Linux',
  Unknown = 'Unknown',
}

export enum DeviceType {
  Mobile = 'mobile',
  Tablet = 'tablet',
  Desktop = 'desktop',
}

export interface DeviceData {
  type: DeviceType;
  os: DeviceOperatingSystem;
}
